import ApiBase from '../../../api-base'
import { ACTIVE_BASE_REST } from '../../../constants'
export default class FurnitureItemTariff extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/tariff/furniture/item'
    super(store, path)
  }
}
